module.exports = __webpack_public_path__ + "img/image-021.9f4c6251.png";